import {ChangeDetectorRef, Pipe, PipeTransform} from '@angular/core';
import {UsersQuery} from "../system/users/user.store";
import {UserQuery} from "../system/users/user.query";

@Pipe({
  name: 'user'
})
export class UserPipe implements PipeTransform {
  private user: UserQuery;
  private val: string;
  constructor(private _ref: ChangeDetectorRef, private usersQuery: UsersQuery) {
  }

  transform(userId?: string): string {
    if (userId && !this.user) {
      this.usersQuery.selectEntity(userId).subscribe(value1 => {
        if (value1) {
          this.user = value1;
          this.val = value1.DisplayName;
          this._ref.markForCheck();
        }
      });
    }
    return this.val;
  }
}
